import { responseHandler } from './apiHelper';

/**
 * Lists the authenticated user's own sale points,
 * on the form [{id, salePoint, zipCodeId, city}]
 * */
export const listMySalePoints = () => fetch(
  '/api/v1/users/me/sale-points',
  {
    credentials: 'same-origin',
  },
)
  .then(responseHandler);

/**
 * Deletes a sale point owned by the authenticated user.
 *
 * @param {number|string} id Sale point id
 * */
export const deleteSalePoint = (id) => fetch(
  `/api/v1/users/me/sale-points/${encodeURIComponent(id)}`,
  {
    method: 'delete',
    credentials: 'same-origin',
  },
)
  .then(responseHandler);

export const getPostalInfo = (postalCode) => fetch(
  `/api/v1/zip-codes/${encodeURIComponent(postalCode)}`,
)
  .then((res) => (res.ok ? res.json() : Promise.reject(new Error('Fant ikke postnummeret'))))
  .then((data) => ({
    data: data.city,
    error: false,
  }))
  .catch((err) => ({
    data: null,
    error: true,
    msg: err.message,
  }));

/**
 * @param {array} grade Either 'university' or 'college'
 * */
export const getSchoolsByGrade = (grade) => fetch(`/api/v1/schools?grade=${encodeURIComponent(grade)}`)
  .then((res) => res.json());

export const getAllSchools = async () => {
  const schoolResponses = Promise.all([
    getSchoolsByGrade('university'),
    getSchoolsByGrade('college'),
  ]);

  return schoolResponses
    .then((grades) => {
      const [university, college] = grades;
      return { university, college };
    });
};

export const addSalePoint = (salePoint) => {
  const school = salePoint.school !== 'default' ? parseInt(salePoint.school, 10) : null;

  return fetch(
    '/api/v1/users/me/sale-points',
    {
      body: JSON.stringify({
        address: salePoint.address,
        postalCode: salePoint.postalCode,
        school,
      }),
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
    .then(responseHandler)
    .then((data) => {
      // Catch user input errors from server
      if (data.error) {
        throw new Error(data.error);
      }

      return data;
    });
};

const getMySchoolSalePoint = async () => fetch(
  '/api/v1/users/me',
  {
    credentials: 'same-origin',
  },
)
  .then(responseHandler)
  .then((user) => {
    if (!user.schoolId || !user.schoolName) {
      return null;
    }

    return {
      id: user.schoolId,
      name: user.schoolName,
      shortName: user.schoolName,
      department: '',
      educationGrade: user.educationGrade || '',
      zipCode: null,
    };
  });

/**
 * Assumes that a user is logged in,
 * and attempts to get all the users sale points.
 * */
export const getExistingSalePoints = async () => {
  const [salePoints, mySchool] = await Promise.all([
    fetch(
      '/api/v1/users/me/sale-points',
      {
        credentials: 'same-origin',
      },
    ).then(responseHandler),
    getMySchoolSalePoint(),
  ]);

  return [
    ...(mySchool ? [mySchool] : []),
    ...salePoints,
  ];
};
